import { Helmet } from 'react-helmet-async';

export interface HelmetProps {
  title: string;
}
// TODO: Add app name prop
export const ACHelmet = ({ title }: HelmetProps) => (
  <Helmet>
    <title> AgileChain | {title}</title>
  </Helmet>
);
